import React, { useEffect, useState } from "react";
import "./aceleradoraCard.scss";
import TitleSection from "../../molecules/title-section";
import ProgressBarAceleradora from "../../atoms/progress-bar-aceleradora/progressBarAceleradora";
import { getFormData, saveForm, getToken, saveAttachment } from "../../../services/formServices";
import FormBodyAceleradora from "../form-body-aceleradora/FormBodyAceleradora";
import { getMunicipalities } from "../../../services/municipalities";
import rawToReact from "../../../utils/rawToReact";
import Modal from "../../molecules/modal/modal";
import FormModal from "../../ui/modal/Modal";
import { navigate } from "gatsby";
import Button from "../../atoms/button/button";
import contentfulRenderOptions from "../../../utils/contentfulRenderOption";
import moment from "moment";
import ModalPreloadCeidData from "../modal-preload-ceid-data/ModalPreloadCeidData";
import { PreRegisterCEIDData } from "../../../interfaces/FormCEID";

type AceleradoraCardProps = {
    tituloPrincipal?: string;
    tituloFormulario?: string;
    descripcionFormulario?: any;
    tituloUbicacion?: string;
    titulosFormulario: Array<any>;
    metaTitulo: string;
    imagenWizard?: string;
    modalSuccess: any;
    modalRegistered: any;
    modalRecuerda: any;
    modalCancelar: any;
    modalDeshabilitar: any;
    pathSharepoint?: string;
    modalEdad: any;
};

interface IModalContent {
    title: string;
    image: string;
    textButton: string;
    url: string;
    textOptionalButton: string;
    urlOptional: string;
}


function AceleradoraCard(props: AceleradoraCardProps) {

    const defaultFormValues = {    
        attachIdDocument: [],
        attachTitle: [],
        docNumber: [],
        registerDate: "",
        birth_date: "",
     }


    const [formValues, setFormValues] = useState(defaultFormValues);
    // cuando se renderiza el grupo todos los inputs obligatorios son agregados a una lista
    const [wizards, setWizards] = useState<any[]>([]);
    const [isDisabledButton, setDisabledButton] = useState<boolean>(false);
    const [inputDisabled, setInputDisabled] = useState<string[]>([]);
    const [fieldsToSkip, setFieldsToSkip]= useState<string[]>([]);
    const [municipality, setMunicipality] = useState("");
    const [continueFormRegistered, setContinueFormRegistered] = useState(true);
    const [cancelForm, setCancelForm] = useState(false);
    const ID_ANTIOQUIA = 1;
    const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
    const [modalContent, setModalContent] = useState<IModalContent>();
    const [isError, setIsError] = useState<boolean>(false);
    const [base64AttachDocument, setBase64AttachDocument] = useState("");
    const [base64AttachDisabilityCertificate, setBase64AttachDisabilityCertificate] = useState("");
    const [base64AttachTitle, setBase64AttachTitle] = useState("");
    const [base64AttachDocumentName, setBase64AttachDocumentName] = useState("");
    const [base64AttachDisabilityCertificateName, setBase64AttachDisabilityCertificateName] = useState("");
    const [base64AttachTitleName, setBase64AttachTitleName] = useState("");
    const [dateStateHelper, setDateStateHelper] = useState<boolean>(false);
    const [displayModalEdad, setDisplayModalEdad] = useState(true);
    
    const allowedFileExtensions = [".jpg", ".png", ".pdf"];
    const [files, setFiles] = useState<File[]>([]);

    const [showModalPreloadCeidData, setShowModalPreloadCeidData] = useState(true);

    const formIsDisabled = !props.modalDeshabilitar?.formularioCeidActivo

    const contentfulModalSuccess = props.modalSuccess;
    const contentfulModalRegistered = props.modalRegistered;
    const registerDate = moment(Date.now()).format('DD-MM-YYYY');
    
    const changeDisplayElement = (selector: string, displayType: string) => {
        document.querySelector(selector).style.display = displayType;
    };

    const handleCancel = () =>{
        setCancelForm(true);
    }

    const closeCancelForm = () => {
        setCancelForm(false);
    };

    // Si hay mas de un grupo, se activa el wizard y boton VOLVER.
    const activeWizard = props.titulosFormulario.length > 1 ? true : false;

    // Crea lista de los titulos para el wizard
    const createWizards = () => {
        let newWizards: any[] = [];
        for (let i = 0; i < props.titulosFormulario.length; i++) {
            if (props.titulosFormulario[i]) {
                newWizards.push({
                    description: props.titulosFormulario[i].tituloGeneral,
                    idx: i,
                });
            }
        }
        
        setWizards([...newWizards]);
    };

    // Estado para determinar el titulo activo del wizard
    useEffect(() => {
        createWizards();
    }, []);

    //Validaciones para los inputs
    const inputRegexValidation = (field: any, value: any) => {
        // Evita que el usuario incluya caracteres no alfabeticos
        if (field === "nameContact" || field === "role") {
            const re = /^[ a-zA-ZÀ-ÿ\u00f1\u00d1]*$/g;
            return re.test(value);
        } else if (field === "phone") {
            return value.length <= 10 ? true : false;
        }
        return true;
    };

    const getBase64URL = async(field, fileInput) => {
        if (fileInput) {
            const reader = new FileReader();
            const readFile = async (oFile) => {
                return new Promise<string>((resolve, reject) => {
                    reader.readAsDataURL(oFile);
                    reader.onload = () => resolve(reader.result as string);
                    reader.onerror = (error) => reject(error);
                });
            }
            
            await readFile(fileInput.files[0]).then((result) => {
                if(field == "attachIdDocument"){ 
                    setBase64AttachDocumentName(fileInput.files[0].name);
                    setBase64AttachDocument(result?.split('base64,')[1]!);
                }
                if(field == "attachDisabilityCertificate"){ 
                    setBase64AttachDisabilityCertificateName(fileInput.files[0].name);
                    setBase64AttachDisabilityCertificate(result?.split('base64,')[1]!);
                }
                if(field == "attachTitle"){ 
                    setBase64AttachTitleName(fileInput.files[0].name);
                    setBase64AttachTitle(result?.split('base64,')[1]!);
                }
            });            
        }
    }

    const resetFormValues = (key: string, selector: string) => {
        setFormValues((prev:any) => {
            const auxFormValues = { ...prev };
            delete auxFormValues[key];
            return auxFormValues;
        });
        const inputSel =  document.querySelector(selector) || {};
        inputSel.value = "";
    };

    function clearRadioSelection(selector: string) {
        var radioButtons = document.getElementsByName(selector);
        for (var i = 0; i < radioButtons.length; i++) {
            radioButtons[i].checked = false;
        }
    }

    const validateAttach = (idInput: string, e?: any) => {
        let totalSize = 0;
        files.forEach(oFile => {
            totalSize += oFile.size;
        });
        const newFile:File = e.target.files![0];
        if (Math.round((newFile.size / 1024)) > 6144 || Math.round((totalSize / 1024)) > 6144) {
            alert("El tamaño del archivo adjunto no puede exceder los 6 MB");
            resetFormValues(idInput, "#input-" + idInput);
            return 1;
        }
        else{
            const isWrongExt = allowedFileExtensions.filter((extension) =>  newFile.name.toLowerCase().endsWith(extension));
            if (isWrongExt.length == 0) {
                alert("Solo se permiten archivos con extensiones " + allowedFileExtensions.toString().toUpperCase() + "\nPor favor, elige otro tipo de archivo.");
                resetFormValues(idInput, "#input-" + idInput);
                return 1;
            }
            else return 0;
        }
    }

    const updateInputValue = (field: string, value: any, type?: string, e?: any) => {
        setFormValues({ ...formValues, ["registerDate"]: registerDate});

        let currentDate = new Date();
        if (field == "birth_date"){
            if((currentDate.getFullYear() - value.split('-')[2]) < props.modalEdad.edadPermitida){
                setDisplayModalEdad(false);
            }
        }

        if (inputRegexValidation(field, value)) {
            setFormValues((prev: any) => {
                return { ...prev, [field]: value };
            });
        }

        if(field == "municipalities"){
            setMunicipality(value);
        }

        if (field == "disability"){
            if(value === "No") {
                changeDisplayElement(".a-input-aceleradora__form-disabilityName", "none");
                changeDisplayElement(".a-input-aceleradora__form-disabilityCertificate", "none");
                clearRadioSelection("disabilityCertificate");
                changeDisplayElement(".a-input-aceleradora__form-attachDisabilityCertificate", "none");
                resetFormValues("attachDisabilityCertificate", "#input-attachDisabilityCertificate");
                changeDisplayElement(".a-input-aceleradora__form-specialReq", "none");
                clearRadioSelection("specialReq");
                changeDisplayElement(".a-input-aceleradora__form-specialReqName", "none");                
                resetFormValues("specialReqName", "#input-specialReqName");
            } else {
                changeDisplayElement(".a-input-aceleradora__form-disabilityName", "block");
                changeDisplayElement(".a-input-aceleradora__form-disabilityCertificate", "block");
                changeDisplayElement(".a-input-aceleradora__form-attachDisabilityCertificate", "none");
                changeDisplayElement(".a-input-aceleradora__form-specialReq", "block");
                changeDisplayElement(".a-input-aceleradora__form-specialReqName", "none");
            }
        }

        if (field == "disabilityCertificate"){
            if(value === "No"){
                changeDisplayElement(".a-input-aceleradora__form-attachDisabilityCertificate", "none");
                resetFormValues("attachDisabilityCertificate", "#input-attachDisabilityCertificate");
            }
            else
                changeDisplayElement(".a-input-aceleradora__form-attachDisabilityCertificate", "block");
        }

        if (field == "specialReq"){
            if(value === "No") {
                changeDisplayElement(".a-input-aceleradora__form-disabilityName", "block");
                changeDisplayElement(".a-input-aceleradora__form-specialReqName", "none");
                resetFormValues("specialReqName", "#input-specialReqName");
            }
            else {
                changeDisplayElement(".a-input-aceleradora__form-disabilityName", "block");
                changeDisplayElement(".a-input-aceleradora__form-specialReqName", "block");
            }
        }

        if (field == "municipalities"){
            if(value === "Medellin") {
                changeDisplayElement(".a-input-aceleradora__form-commune", "block");
            } else {
                changeDisplayElement(".a-input-aceleradora__form-commune", "none");
            }
        }

        if (field == "municipalities"){
            if(value === "Otro") {
                changeDisplayElement(".a-input-aceleradora__form-other_municipality", "block");
            } else {
                changeDisplayElement(".a-input-aceleradora__form-other_municipality", "none");
            }
        }

        if (field == "secondLanguage"){
            if(value === "Sí") {
                changeDisplayElement(".a-input-aceleradora__form-languageName", "block");
                changeDisplayElement(".a-input-aceleradora__form-otherLanguage", "none");
                changeDisplayElement(".a-input-aceleradora__form-secondLanguageLevel", "block");
            } else {
                changeDisplayElement(".a-input-aceleradora__form-languageName", "none");
                changeDisplayElement(".a-input-aceleradora__form-otherLanguage", "none");
                changeDisplayElement(".a-input-aceleradora__form-secondLanguageLevel", "none");
            }
        }

        if (field == "languageName"){
            if(value === "Otro") {
                changeDisplayElement(".a-input-aceleradora__form-otherLanguage", "block");
            } else {
                changeDisplayElement(".a-input-aceleradora__form-otherLanguage", "none");
            }
        }

        if (field == "previousExperience"){
            if(value === "Sí") {
                changeDisplayElement(".a-input-aceleradora__form-previousExperienceDescr", "block");
            } else {
                changeDisplayElement(".a-input-aceleradora__form-previousExperienceDescr", "none");
            }
        }
        
        if (field == "attachIdDocument"){
            if (validateAttach("attachIdDocument", e) == 0){
                getBase64URL(field, document.getElementById('input-attachIdDocument')).then((result) => {});
            }
        }

        if (field == "attachDisabilityCertificate"){
            if (validateAttach("attachDisabilityCertificate", e) == 0){
                getBase64URL(field, document.getElementById('input-attachDisabilityCertificate')).then((result) => {});
            }
        }

        if (field == "attachTitle"){
            if (validateAttach("attachTitle", e) == 0){
                getBase64URL(field, document.getElementById('input-attachTitle')).then((result) => {});
            }
        }
    };
    
    const createPayload = () => {
        const payload: any = {
            idForm: 10,
            answers: [],
        };

        Object.entries(formValues).forEach(([key, value]) => {
            payload.answers.push({ contentfulId: key, answer: value });
        });
        return payload;
    };

    const handleSubmitForm = async () => {
        let spPayload;
        
        spPayload = {
            "folderAddress": props.pathSharepoint,
            "attachments": [
                {
                    "fileBase64": base64AttachDocument.length > 0 ? base64AttachDocument : "",
                    "fileType": "file",
                    "fileName": base64AttachDocument.length > 0 ? base64AttachDocumentName : ""
                },
                {
                    "fileBase64": base64AttachDisabilityCertificate.length > 0 ? base64AttachDisabilityCertificate : "",
                    "fileType": "file",
                    "fileName": base64AttachDisabilityCertificate.length > 0 ? base64AttachDisabilityCertificateName : ""
                },
                {
                    "fileBase64": base64AttachTitle.length > 0 ? base64AttachTitle : "",
                    "fileType": "file",
                    "fileName": base64AttachTitle.length > 0 ? base64AttachTitleName : ""
                }
            ]
        }

        setDisabledButton(true);
        const payload = createPayload();
        const token = await getToken();
        const responseAttach = await saveAttachment(token, spPayload);
        
        if (responseAttach.data.status == 200){
            payload.answers.forEach((answer) => {
                if (answer["contentfulId"] == "attachIdDocument") {
                    if (base64AttachDocument.length > 0){
                        answer["answer"] = responseAttach.data.data[base64AttachDocumentName];
                    }
                    else answer["answer"] = "(sin adjunto)";
                }

                if (answer["contentfulId"] == "attachDisabilityCertificate") {
                    if (base64AttachDisabilityCertificate.length > 0){
                        answer["answer"] = responseAttach.data.data[base64AttachDisabilityCertificateName];
                    }
                    else answer["answer"] = "(sin adjunto)";
                }

                if (answer["contentfulId"] == "attachTitle") {
                    if (base64AttachTitle.length > 0){
                        answer["answer"] = responseAttach.data.data[base64AttachTitleName];
                    }
                    else answer["answer"] = "(sin adjunto)";
                }
            });
        }

        if (responseAttach.data.status == 400){
            payload.answers.forEach((answer) => {
                if (answer["contentfulId"] == "attachIdDocument" || 
                        answer["contentfulId"] == "attachDisabilityCertificate" || 
                            answer["contentfulId"] == "attachTitle") {
                    answer["answer"] = "(sin adjunto)";
                }
            });
        }

        const response = await saveForm(payload, token);
        
        handleModalContent(response.data.status);
        setIsOpenModal(true);
        setDisabledButton(false);
    };

    // cuando se renderiza el grupo todos los inputs obligatorios son agregados a una lista
    const createInputGroupRequiredList = () => {
        const inputList: any = [];
        props.titulosFormulario.forEach((tituloFormulario) => {
            tituloFormulario.referenciaFormulario.forEach((input) => {
                if (input.obligatorio) {
                    inputList.push(input.nombreId);
                }
            });
        });
        return inputList;
    };

    const municipalitiesList = async () => {
        try {
            setDisabledButton(true);
            const data = await getMunicipalities(ID_ANTIOQUIA);
            const municipalities = [];
            Object.entries(data.data.data).forEach(([key, value]) => {
                municipalities.push(value.name);
            });
            municipalities.push("Otro")

            municipalities.sort();
            // Agrega los municipalities como options al campo de tipo select correspondiente
            Object.entries(
                props.titulosFormulario[2].referenciaFormulario
            ).forEach(([key, value]) => {
                if (value.nombreId === "municipalities") {
                    props.titulosFormulario[2].referenciaFormulario[
                        key
                    ].listaSelect = municipalities;
                }
            });
            setDisabledButton(false);
        } catch (error) {
            console.log("API Error:", error);
        }
    };

    const handleClickNext = async () => {
        const token = await getToken();
        const request = await getFormData(10, token);
        let flagRegistered = false;
        request.data.forEach((docNumberData) => {
            const item = docNumberData.answerData;
            let flagDocNumber = false;
            let flagDocType = false;

            Object.entries(formValues).forEach(([key, value]) => {
                if (`${key}` === "document_type"){
                    if (`${value}` === item.document_type){
                        flagDocType = true
                    }
                }

                if (`${key}` === "docNumber"){
                    if (`${value}` === item.docNumber){
                        flagDocNumber = true;
                    }
                }

                if (flagDocType && flagDocNumber){
                    if(new Date(docNumberData.creationDate) >= new Date(props.modalDeshabilitar.fechaInicioConvocatoria)){
                        flagRegistered = true;
                        setContinueFormRegistered(false);
                        setModalContent({
                            title: props.modalRegistered.tituloPrincipal,
                            image: props.modalRegistered.imagenFormulario.file.url,
                            textButton: props.modalRegistered.tituloBoton,
                            url: props.modalRegistered.redireccionBoton,
                            textOptionalButton: props.modalRegistered.tituloBotonOpcional,
                            urlOptional: props.modalRegistered.redireccionBotonOpcional,
                        });
                    }
                }
            });
        });
        
        return flagRegistered;
    }

    useEffect(() => {
        municipalitiesList();
        handleClickNext(); 
    }, []);

    useEffect(() => {
        let fieldsToSkipAux:string[] = [];
        if (formValues.disability == "No"){
            fieldsToSkipAux.push("disabilityName", "specialReq", "specialReqName");
        }
        setFieldsToSkip(fieldsToSkipAux);
    },[formValues])

    // Guarda en un estado con el contenido de los modales que se renderizan al finalizar el formulario
    const handleModalContent = (status: number) => {
        if (status === 200) {
            setModalContent({
                title: props.modalSuccess.tituloPrincipal,
                image: props.modalSuccess.imagenFormulario.file.url,
                textButton: props.modalSuccess.tituloBoton,
                url: props.modalSuccess.redireccionBoton,
                textOptionalButton: props.modalSuccess.tituloBotonOpcional,
                urlOptional: props.modalSuccess.redireccionBotonOpcional,
            });
            setIsError(false);
        }
    };

    // Retorna el contenido de un modal dependiendo del resultado al completar un formulario
    const getContentModal = () => {
        // Si hay error al completar el formulario se renderiza el contenido del modal no exitoso
        if (!isError) {
            // Si se completa el formulario se renderiza el contenido del modal exitoso
            return (
                <p>
                    {rawToReact(
                        contentfulModalSuccess.descripcionFormulario.raw,
                        contentfulRenderOptions
                    )}
                </p>
            );
        }
    };

    const closeForm = () => {
        navigate(`https://www.comfama.com/trabajo-con-proposito/empleo/centro-de-empleo-para-la-industria-digital/`);
    };

    const closeModalEdad = () => {
        setDisplayModalEdad(true);
        setDateStateHelper(true)
        setFormValues({ ...formValues, ["birth_date"]: ""});

        return false;
    };

    const handlePreloadDataToForm = (data: NonNullable<PreRegisterCEIDData['answerData']> ) => {

      const formMunicipalities: string[] =  props.titulosFormulario[2]?.referenciaFormulario?.find(input => input?.nombreId === "municipalities")?.listaSelect || []

      const selectedMunicipality = formMunicipalities?.find(m => m.toLowerCase()?.trim() === data?.city?.toLowerCase()?.trim()) || ""

      const loadedData = {
         complete_name: data?.complete_name || "",
         document_type: data?.document_type || "",
         docNumber: data?.docNumber || "",
         birth_date: data?.birth_date || "",
         email: data?.email || "",
         cellphone: data?.cellphone || "",
         additionalCellphone: data?.additionalCellphone || "",
         municipalities: selectedMunicipality || "",
         lastAcademicLevel: data?.lastAcademicLevel || "",
         program: data?.program || "",
      }

      setFormValues((pre) => ({
         ...pre,
         ...loadedData as unknown as typeof pre
      }))

      setShowModalPreloadCeidData(false)
    }

    return (
        <div className={`m-aceleradora-card${isOpenModal ? "__successModal" : ""}`}>
            {/* Renderiza el modal */}
            {!isOpenModal && (
                <>
                <div className="m-aceleradora-card__header">
                    <TitleSection title={props.tituloPrincipal} />
                    <p className="m-subtitle-section">
                        {props.descripcionFormulario && (
                            contentfulRenderOptions(
                                props.descripcionFormulario,
                            )
                        )}
                    </p>
                    {/* Renderiza la barra de progreso del formulario */}
                    <ProgressBarAceleradora
                        formValues={formValues}
                        requiredValues={createInputGroupRequiredList()}
                        fieldsToSkip={fieldsToSkip}
                    ></ProgressBarAceleradora>
                </div>
                <div className="m-aceleradora-card__body">
                    <div className="m-aceleradora-card__body__content">
                        <FormBodyAceleradora
                            // Campos y estilos del formulario
                            titulosFormulario={props.titulosFormulario}
                            genericClassNameForm={props.metaTitulo}
                            setInputValue={updateInputValue}
                            formValues={formValues}
                            handleSubmitForm={handleSubmitForm}
                            inputDisabled={inputDisabled}
                            isDisabledButton={isDisabledButton}
                            handleEvent={handleClickNext}
                            fieldsToSkip={fieldsToSkip}
                            handleCancelButton={handleCancel}
                            modalRemember={props.modalRecuerda}
                            modalDeshabiltar={props.modalDeshabilitar}
                            imagenWizard={props.imagenWizard}
                            descripcionWizard={props.tituloUbicacion}
                            dateStateHelper={dateStateHelper}
                            setDateStateHelper={setDateStateHelper}
                        >
                            {cancelForm && (
                             <FormModal
                             showModal={cancelForm}
                             onClose={closeCancelForm}>
                                 <div
                                     className={`m-modal-container-validation`}
                                 >
                                     <h3>{props.modalCancelar.tituloPrincipal}</h3>
                                     <div className="a-button-magenta-container__modal-cancelar">
                                         <Button
                                            type="button"
                                            classname="a-button-magenta"
                                            text={props.modalCancelar.tituloBoton} 
                                            isDisabled={false}
                                            onClickAction={() => {
                                                closeCancelForm()
                                            }}
                                         >
                                         </Button>
                                     </div>
                                     <div>
                                     <Button
                                            type="button"
                                            classname="m-modal-content__buttonbar__cancel"
                                            text={props.modalCancelar.tituloBotonOpcional} 
                                            isDisabled={false}
                                            onClickAction={() => {
                                                closeForm()
                                            }}
                                            >
                                    </Button>
                                     </div>
                                 </div>
                            </FormModal>
                            )}
                        </FormBodyAceleradora>
                    </div>
                </div>
                </>
            )}
            {/* Renderiza el modal para el registro exitoso */}
            {isOpenModal && (
                <Modal
                    image={modalContent?.image ? modalContent.image : ""}
                    title={modalContent?.title ? modalContent.title : ""}
                    textButton={
                        modalContent?.textButton ? modalContent.textButton : ""
                    }
                    url={modalContent?.url ? modalContent.url : ""}
                >
                    <div className="m-aceleradora-card__content-modal">
                        {getContentModal()}
                    </div>
                </Modal>
            )}

            {/* Renderiza el modal si ya esta registrado */}
            {!continueFormRegistered && (
                <FormModal showModal={!continueFormRegistered} onClose={closeForm}>
                <div className="m-modal-content">
                    <div className="m-modal-content__form">
                        <div className="m-modal-content__form__title">
                            {modalContent.title}
                        </div>
                        <div className="m-modal-content__form__descr">
                            <p>
                                {rawToReact(
                                    contentfulModalRegistered.descripcionFormulario.raw,
                                    contentfulRenderOptions
                                )}
                            </p>
                        </div>
                    </div>
                    <div className="m-modal-content__buttonbar">
                        <Button
                            type="link"
                            text={modalContent?.textButton}
                            classname={"m-modal-content__buttonbar__retry"}
                            isDisabled={false}
                            href={modalContent?.url ? modalContent.url : ""}
                        />
                        <Button
                            type="link"
                            text={modalContent?.textOptionalButton}
                            classname={"m-modal-content__buttonbar__back"}
                            isDisabled={false}
                            href={modalContent?.urlOptional ? modalContent.urlOptional : ""}
                        />
                    </div>
                </div>
            </FormModal>
            )}
            {/* Renderiza el modal de validacion de edad, que solo se muestra en el segundo paso */}
            {!displayModalEdad && (
                <FormModal showModal={displayModalEdad} onClose={closeModalEdad}>
                    <div className="m-modal-content">
                        <div className="m-modal-content__form">
                            <img className="m-modal__image" 
                                src={props.modalEdad.imagenFormulario.file.url}
                                alt={props.modalEdad.tituloPrincipal} />
                            <div className="m-modal-content__form__title">
                                {props.modalEdad.tituloPrincipal}
                            </div>
                            <div className="m-modal-content__form__recuerda">
                                <p>
                                    {rawToReact(props.modalEdad.descripcionFormulario.raw, contentfulRenderOptions)}
                                </p>
                            </div>
                        </div>
                        <div className="m-modal-content__buttonbar">
                            <Button
                                type="link"
                                text={props.modalEdad?.tituloBoton}
                                classname={"m-modal-content__buttonbar__back"}
                                isDisabled={false}
                                onClickAction={closeModalEdad}
                            />
                        </div>
                    </div>
                </FormModal>
            )}

            {/* Modal preload data */}
            {
               showModalPreloadCeidData && !formIsDisabled ? (
                  <ModalPreloadCeidData
                     showModal
                     onSuccesPreloadData={handlePreloadDataToForm}
                     onClose={() => {
                        setShowModalPreloadCeidData(false);
                     }}
                  />
               ) : null
            }
           
        </div>
    );
}

export default AceleradoraCard;